<template>
  <div class="comment-list">
    <scroll-comp ref="scrollComp" :page-load="getList">
      <template>
        <a
          v-for="item in list"
          :key="item.id"
          :href="getJumpWikiDetailUrl(item.game.alias, item.game.id, item.content_id)"
          class="item"
          target="_blank"
        >
          <div class="content">
            <div v-html="replaceEmoji(xss(item.contentFormat.text))"></div>
            <div v-if="item.contentFormat.imgs.length" class="comment-img-wrapper">
              <template v-for="(img, index) in item.contentFormat.imgs">
                <div v-if="index < 3" :key="index" class="img-item">
                  <img :src="img" alt="" />
                  <div v-if="index == 2 && item.contentFormat.imgs.length > 2" class="mask">
                    +{{ item.contentFormat.imgs.length - 3 }}
                  </div>
                </div>
              </template>
            </div>
            <span class="date">{{ item.created_at | dateFromNow }}</span>
          </div>
          <div class="origin">
            <span>回复{{ item.pid > 0 ? "评论" : "帖子" }}:</span>
            <span v-html="replaceEmoji(item.replayContentFormat)"></span>
          </div>
        </a>
      </template>
    </scroll-comp>
  </div>
</template>

<script>
import ScrollComp from "@/components/Scroll";
import { apiCommentListUid } from "@/api/commentApi";
import { getJumpWikiDetailUrl } from "../../plugins/util";

export default {
  name: "comment",
  mixins: [],
  props: {},
  model: {},
  components: { ScrollComp },
  data() {
    return {
      pagination: {
        limit: 10,
        page_no: 0,
        page_total: 1,
        total: 0
      },
      list: []
    };
  },
  computed: {},
  methods: {
    getJumpWikiDetailUrl,
    getReplayContent(content) {
      let $content = document.createElement("div");
      $content.innerHTML = content;
      let text = $content.innerText;
      $content.querySelectorAll("img").forEach((img, index) => {
        text += "[图片]";
      });
      return text;
    },
    getContent(content) {
      let $content = document.createElement("div");
      $content.innerHTML = content;
      let text = $content.innerText;
      let imgs = [];
      $content.querySelectorAll("img").forEach(img => {
        imgs.push(img.getAttribute("src"));
      });
      return {
        text,
        imgs
      };
    },
    goPage(item) {
      this.$router.push(`/${item.content_id}.html`);
    },
    getList() {
      let { pagination, $refs, $route } = this;
      if ($refs.scrollComp.loadStatus == "end") return;
      ++pagination.page_no;
      let params = {
        ...pagination,
        uid: $route.params.id
      };
      $refs.scrollComp.loadStatus = "loading";
      apiCommentListUid(params)
        .then(res => {
          if (res.code == 0) {
            res.data.forEach(item => {
              item.contentFormat = this.getContent(item.content);
              item.replayContentFormat = this.getReplayContent(item.reply_content);
            });

            this.list = this.list.concat(res.data);
            this.pagination = res.meta.pagination;
          }
        })
        .finally(_ => {
          // 达到最大页数后，不触发翻页方法；
          if (this.pagination.page_no >= this.pagination.page_total) {
            $refs.scrollComp.loadStatus = "end";
          } else {
            $refs.scrollComp.loadStatus = "";
          }
        });
    },
    replaceEmoji(str = "") {
      const emojiMap = this.$store.state.emojiFlatMap;
      let replacedString = str.replace(/_\((.*?)\)/g, (match, p1) => {
        return emojiMap[`_(${p1})`] || "";
      });
      const isAllImages = /^\s*(<img[^>]*>\s*)+$/.test(replacedString);
      if (isAllImages) {
        replacedString = replacedString.replace(/40px;/g, "60px;");
      }
      return replacedString;
    }
  },
  watch: {},
  created() {},
  mounted() {
    this.getList();
  },
  updated() {},
  beforeDestroy() {},
  destroyed() {}
};
</script>

<style lang="less" scoped>
.comment-list {
  padding: 16px 28px;
}
.item {
  border-bottom: 1px solid @border-basic;
  padding-bottom: 14px;
  display: block;

  & + .item {
    margin-top: 10px;
  }

  .content {
    font-size: 16px;
    color: #151515;
    line-height: 24px;
    margin-bottom: 5px;

    .date {
      font-size: 14px;
      color: #999999;
      font-weight: initial;
    }
  }

  .comment-img-wrapper {
    display: flex;
    margin-bottom: 8px;
    margin-top: 8px;

    .img-item {
      width: 110px;
      height: 100px;
      cursor: pointer;
      position: relative;
      border-radius: 6px;
      overflow: hidden;

      & + .img-item {
        margin-left: 12px;
      }

      .mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: fade(#000, 70%);
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 16px;
      }
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .origin {
    padding: 12px;
    background: #f7f7f7;
    border-radius: 4px;
    display: block;
    font-size: 14px;
    color: #666;
    cursor: pointer;
  }
}
</style>
